



















import { Component, Vue } from "vue-property-decorator";

@Component
export default class App extends Vue {
  audio!: HTMLAudioElement;
  playing: boolean = false;
  mounted() {
    setTimeout(() => {
      this.audio = <HTMLAudioElement>document.querySelector("audio");
      document.addEventListener("WeixinJSBridgeReady", this.playAudio);

      document.addEventListener("click", this.playAudio);
      this.audio.addEventListener("playing", () => {
        this.playing = true;
        document.removeEventListener("click", this.playAudio);
      });
      this.audio.addEventListener("pause", () => {
        this.playing = false;
      });
    }, 25);
  }
  playAudio() {
    if (this.audio && this.audio.paused) {
      this.audio.play();
      this.playing = true;
    }
  }
  changePlay() {
    if (this.audio.paused) {
      this.audio.play();
    } else {
      this.audio.pause();
    }
  }
  goBm() {
    location.href = "http://www.nbd.com.cn/corp/2021jrsign/index.html#/";
  }
}
